import React from "react"
import clsx from "clsx"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import { isDirectionLtr } from "utils"
import { languageSuffixMap } from "constant"
import { LazyImage } from "components"
import classes from "./KfcsItem.module.scss"

const KfcsItem = (props) => {
  const {
    category,
    selectedCategory,
    setSelectedCategory,
    setSelectedSubCategory
  } = props

  const history = useHistory()

  const i18n = useTranslation()[1]

  const groupedFoodIdsBasedOnCategory =
    useSelector(state => state.groupedFoodIdsBasedOnCategory)

  const handleClick = () => {
    if (category._id === selectedCategory?._id) return

    setSelectedCategory(category)

    setSelectedSubCategory(null)

    history.push(`/kiosk-foods?categoryId=${category._id}`)
  }

  const field = `name${languageSuffixMap[i18n.language]}`

  const categoryName = category[field]

  const haveFoods =
    groupedFoodIdsBasedOnCategory[category._id]?.length > 0

  if (!haveFoods) return null

  return (
    <div
      onClick={handleClick}
      className={clsx(
        classes["container"],
        selectedCategory?._id === category._id && classes["active"]
      )}
    >
      <LazyImage
        src={category.image}
        imageWidth={100}
        quality={80}
        alt={categoryName}
        className={clsx(classes["image"],
          isDirectionLtr(i18n.language) && classes["image-ltr"]
        )}
      />

      <div className={classes["name"]}>
        {categoryName}
      </div>
    </div>
  )
}

export default React.memo(KfcsItem)